export default {"src":"/_next/static/media/follow-wechat.814ea9c2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};